import { tv } from "@/utils/tv.config";

export const optionClasses = tv({
  slots: {
    selectItem: [
      "flex",
      "min-w-[var(--anchor-width)]",
      "cursor-pointer",
      // "grid-cols-[0.75rem_1fr]",
      "items-center",
      "gap-2",
      "py-3",
      "pr-4",
      "pl-2.5",
      "text-sm",
      "leading-4",
      "outline-none",
      "select-none",

      // Group data-side=none variants
      "group-data-[side=none]:min-w-[calc(var(--anchor-width)+1rem)]",
      "group-data-[side=none]:pr-12",
      "group-data-[side=none]:text-base",
      "group-data-[side=none]:leading-4",

      // Highlighted state
      "data-[highlighted]:relative",
      "data-[highlighted]:z-0",
      "data-[highlighted]:text-black",
      "data-[highlighted]:before:absolute",
      "data-[highlighted]:before:inset-x-1",
      "data-[highlighted]:before:inset-y-0",
      "data-[highlighted]:before:z-[-1]",
      "data-[highlighted]:before:rounded-lg",
      "data-[highlighted]:before:bg-primary-main/10",
    ],
    selectItemIndicator: ["flex-grow-0"],
    selectItemIndicatorIcon: ["size-4"],
    selectItemText: ["flex-grow pl-2"],
  },
});

export const {
  selectItem: selectItemClasses,
  selectItemIndicatorIcon: selectItemIndicatorIconClasses,
  selectItemIndicator: selectItemIndicatorClasses,
  selectItemText: selectItemTextClasses,
} = optionClasses();
